// ============================================================
// TEXTOVÝ OBSAH WEBU – všetko na jednom mieste, jednoducho uprav.
// ============================================================

// --- Stručné zhrnutie vozidla (krátke heslá, bez ikon) ---
export const vehicleHighlights = [
  '4 miesta na cestovanie',
  '4 miesta na spanie',
  'Automatická prevodovka',
  'Kuchynka a chladnička',
  'Nezávislé kúrenie',
  'Zdvíhacia strecha',
];

// --- Krátke bloky "Všetko potrebné máš poruke" pri vozidle ---
export const vehicleFocusPoints = [
  {
    title: 'Spanie pre štyroch',
    text: 'Dve lôžka nájdeš v zdvíhacej streche a ďalšie vznikne rozložením zadnej lavice. Večer zaparkuješ, pripravíš postele a ráno pokračuješ ďalej.',
  },
  {
    title: 'Kuchynka na cestách',
    text: 'Plynový varič, chladnička, drez s tečúcou vodou, riad aj kávovar. Raňajky si môžeš pripraviť pri jazere, na horskom priesmyku alebo v kempe.',
  },
  {
    title: 'Pohodlie aj v chladnejších dňoch',
    text: 'Nezávislé kúrenie spríjemní chladné rána aj jesenné výlety. K dispozícii máš tiež 230 V prípojku a USB nabíjanie.',
  },
  {
    title: 'Sedenie vonku aj vnútri',
    text: 'Kempingový stôl a stoličky sú súčasťou výbavy. Keď je pekne, rozložíš si sedenie vonku. Keď prší, zostaneš pohodlne vnútri.',
  },
];

// --- Úvodný text pod hero sekciou ---
export const pitchText = {
  heading: 'Dovolenka, ktorú nemusíš plánovať do posledného detailu',
  paragraphs: [
    'S Californiou máš dopravu, spanie aj malé zázemie stále so sebou. Môžeš zostať dlhšie tam, kde sa ti páči, zmeniť trasu podľa počasia alebo sa ráno jednoducho rozhodnúť, kam pôjdeš ďalej.',
    'Auto sa šoféruje podobne ako bežné osobné vozidlo. Po zaparkovaní sa z neho stane pohodlné miesto na varenie, oddych a spanie pre štyroch.',
  ],
};

// --- Postup rezervácie ---
export const bookingSteps = [
  { title: 'Vyber si termín', text: 'V kalendári uvidíš aktuálne voľné dni.' },
  { title: 'Pošli rezerváciu', text: 'Potvrdíme dostupnosť, výslednú cenu a dohodneme čas prevzatia.' },
  { title: 'Prevezmi si Californiu pri Košiciach', text: 'Vozidlo dostaneš čisté a pripravené. Pri prevzatí si spolu prejdeme strechu, postele, kuchynku, kúrenie aj pripojenie elektriny.' },
  { title: 'Vyraz', text: 'Kam pôjdeš, je už na tebe.' },
];

// --- Pre koho je California ---
export const audienceFit = [
  { title: 'Pre dvojice', text: 'Na predĺžený víkend, cestu za turistikou alebo niekoľko dní pri mori.' },
  { title: 'Pre rodiny', text: 'Deti získajú vlastné miesto na spanie v streche a vy môžete každý deň objaviť nové miesto.' },
  { title: 'Pre kamarátov', text: 'Štyri miesta na cestovanie aj spanie a možnosť zobrať bicykle či paddleboard.' },
  { title: 'Pre prvý roadtrip', text: 'California je kompaktná, jednoducho sa šoféruje a pri prevzatí ti všetko vysvetlíme.' },
];

// --- Rozbaľovací zoznam kompletnej výbavy ---
export const equipmentGroups = [
  {
    title: 'Kuchyňa',
    items: ['Dvojplatničkový plynový varič', 'Chladnička', 'Drez s tečúcou vodou', 'Riad a príbor pre 4 osoby', 'Hrnce a panvica', 'Kávovar Nespresso s kapsuľami'],
  },
  {
    title: 'Spanie',
    items: ['Rozkladacia posteľ pre 2 osoby dole', 'Posteľ pre 2 osoby v streche', 'Zatemňovacie rolety', 'Posteľná bielizeň (voliteľné za doplatok)'],
  },
  {
    title: 'Voda a energia',
    items: ['Nádrž na čistú vodu 30 l', 'Nádrž na odpadovú vodu', 'Druhá batéria', '230 V prípojka na kempe', 'USB porty a káble', 'Invertor 230 V'],
  },
  {
    title: 'Kúrenie a komfort',
    items: ['Nezávislé naftové kúrenie', 'Klimatizácia', 'Vonkajšia markíza', 'Kempingové stoličky a stôl', 'Kempingové osvetlenie','Koberec pod markízou'],
  },
  {
    title: 'Úložné priestory',
    items: ['Skrine a zásuvky v obytnej časti', 'Batožinový priestor', 'Odkladacie priestory pod sedačkou', 'Držiaky na bicykle (voliteľné za doplatok)', 'Praktické háčiky na odkladanie vecí'],
  },
];

// --- FAQ (zástupné odpovede – uprav podľa potreby) ---
export const faqItems = [
  { question: 'Prečo si vybrať Californiu?', answer: 'V porovnaní s veľkým karavanom cestujete oveľa lacnejšie a bezpečnejšie vďaka jazdným vlastnostiam osobného auta. Nevzťahujú sa na vás obmedzenia vjazdu do miest a podzemných garáží. A, v neposlednom rade, je to oveľa viac cool kára :)' },
  { question: 'Môžem cestovať do zahraničia?', answer: 'Áno, s vozidlom môžete cestovať po celej Európe. VW California je ideálnym vozidlom na výlety do Rakúska, Slovinska, Talianska, Švajčiarska, alebo sa vydať spoznávať charizmatický Balkán.' },
  { question: 'Môžem vziať so sebou domáce zviera?', answer: 'Bohužial s ohľadom na iných záujemcov a možné alergie štvornohých miláčikov do Californie nepúšťame.' },
  { question: 'Čo je v cene prenájmu?', answer: 'Kompletná výbava vozidla, kempingový nábytok, kuchynské vybavenie a diaľničná známka SR. Presný zoznam nájdete v sekcii Výbava.' },
  { question: 'Je obmedzený počet kilometrov?', answer: 'V cene je zahrnutých 350 km na deň. Nad limit sa účtuje poplatok za kilometer.' },
  { question: 'Ako je vozidlo poistené?', answer: 'Vozidlo má havarijné poistenie s platnosťou v celej EÚ. Spoluúčasť je krytá vratnou zálohou.' },
  { question: 'Kde si vozidlo vyzdvihnem?', answer: 'Vozidlo si vyzdvihnete v obci Šemša pri Košiciach. Vaše auto si môžete nechať zaparkované na našom súkromnom parkovisku Presné miesto a čas si dohodneme pri potvrdení rezervácie.' },
  { question: 'Aká je minimálna dĺžka prenájmu?', answer: 'Minimálna dĺžka prenájmu sú 3 dni. Účtuje sa každý deň vrátane dňa vyzdvihnutia a vrátenia.' },
  { question: 'Koľko stojí prenájom VW California??', answer: 'Cena prenájmu VW California závisí od sezóny a dĺžky prenájmu. Presnú cenu uvidíte priamo v rezervačnom kalendári po výbere termínu. Pri dlhších prenájmoch poskytujeme výhodnejšie ceny za deň.' },
  { question: 'Aký vodičský preukaz potrebujem?', answer: 'Na vedenie VW California postačuje vodičský preukaz skupiny B.' },
  { question: 'Má VW California toaletu?', answer: 'VW California nemá zabudovanú toaletu.' },
  { question: 'Koľko ľudí sa v aute vyspí?', answer: 'Vozidlo má miesta na cestovanie aj spanie pre štyroch.' },
  { question: 'Je vhodné aj na chladnejšie počasie?', answer: 'Áno. California má nezávislé kúrenie, takže je vhodná aj na jarné či jesenné cesty.' },
  { question: 'Musím mať skúsenosti s obytným autom?', answer: 'Nie. VW California je vhodná aj pre úplných začiatočníkov. Pred odchodom vás naučíme všetko potrebné.' },
  { question: 'Aká je výška zálohy?', answer: 'Vratná záloha (kaucia) je 1 000 €. Vraciame ju po vrátení nepoškodeného vozidla.' },
];

// --- Tipy na výlety (zástupný obsah – uprav texty aj údaje) ---
export const tripIdeas = [
  { title: 'Vysoké Tatry', distance: '90 km', nights: '2–3 noci', description: 'Štíty, plesá a najkrajšie kempy na Slovensku len hodinu cesty od Košíc. Vrelo odporúčame kemping v Račkovej doline', image: '/images/trip-tatry.jpg', mapUrl: 'https://www.pribylina.sk/obec/cestovny-ruch-a-sluzby/autocamp-rackova-dolina/' },
  { title: 'Slovenský raj', distance: '70 km', nights: '1–2 noci', description: 'Rokliny, rebríky a vodopády – dobrodružstvo pre celú rodinu.', image: '/images/trip-raj.jpg', mapUrl: 'https://maps.google.com/?q=Slovenský+raj' },
  { title: 'Tokaj', distance: '60 km', nights: '1–2 noci', description: 'Vinice, degustácie a pokojné večery medzi vinohradmi.', image: '/images/trip-tokaj.jpg', mapUrl: 'https://www.campingmalabara.sk' },
  { title: 'Slovinsko', distance: '800 km', nights: '7+ nocí', description: 'Tu sa California cíti ako doma – Spoznajte nádherné jazerá, hory a krištálovo čisté rieky.', image: '/images/trip-slovinsko.jpg', mapUrl: 'https://www.camp-bohinj.si' },
  { title: 'Chorvátsko', distance: '750 km', nights: '7+ nocí', description: 'Jadran, ostrovy a kempy pri mori. Klasika, ktorá nikdy nesklame.', image: '/images/trip-chorvatsko.jpg', mapUrl: 'https://maps.google.com/?q=Chorvátsko' },
  { title: 'Alpy', distance: '450 km', nights: '4–7 nocí', description: 'Rakúske priesmyky, horské jazerá a serpentíny ako z pohľadnice.', image: '/images/trip-alpy.jpg', mapUrl: 'https://maps.google.com/?q=Alpy+Rakúsko' },
];

// --- Plánovač trasy: obľúbené destinácie s reálnou vzdialenosťou z Košíc ---
export const routeDestinations = [
  { name: 'Vysoké Tatry', km: 90 },
  { name: 'Slovenský raj', km: 70 },
  { name: 'Tokaj', km: 60 },
  { name: 'Budapešť', km: 260 },
  { name: 'Slovinsko', km: 700 },
  { name: 'Krakov', km: 260 },
  { name: 'Záhreb', km: 750 },
  { name: 'Split', km: 1050 },
  { name: 'Salzburg (Alpy)', km: 640 },
];

// --- Recenzie ---
// Novú recenziu pridáš skopírovaním bloku { ... } a úpravou textu.
export const reviews = [
   {
    name: 'Robo B.',
    date: 'august 2026',
    rating: 5,
    text: 'Californiu sme si prenajali dvaja dospeli so 4 rocnym dietatom. Navstivili sme dva rozne kempy na Slovensku, ktore sme si vdaka Californii uzili na plno! Vybavenie je skvele - od pohodlneho spania cez kuchynske vybavenie az po odkladacie priestory (Ano aj vesiaky). Vsetko nastavenie a ovladanie je jednoduche. Takisto treba vyzdvihnut pristup majitela, ktory ma cely proces od rezervacie az po odovzdanie naozaj dobre zabezpeceny. Vsetky potrebne informacie dostanete jednak vopred emailom, ako aj pri prevzati vozidla spolu s demonstraciou. Je to skvely zazitok, ktory odporucam kazdemu a urcite si ju poziciame znova! ',
    photo: '/images/review-1.jpg',
  }, 
  {
    name: 'Martin H.',
    date: 'júl 2026',
    rating: 5,
    text: 'Za mňa super spôsob ako vyvetrať hlavu úplne novým spôsobom! Kombinácia slobody, prírody, komfortu je úplná pecka. Určite to zopakneme.',
    photo: '/images/review-1.jpg',
  },
  {
    name: 'Jarmila J.',
    date: 'júl 2026',
    rating: 5,
    text: 'Vrátili sme sa v Californii s manželom do mladých liet. Výlet na Šíravu ako za starých čias. Rada odporúčam všetkým dôchodcom. Jarmila :)',
    photo: '/images/review-3.jpg',
  },
  {
    name: 'Maroš S.',
    date: 'júl 2026',
    rating: 5,
    text: 'Chcem sa poďakovať ešte raz za prenajatie autíčka 👍 všetko bolo super. Vynikajúci prístup z vašej strany od začiatku do konca. V aute je všetko potrebné nič nám nechýbalo. Dcére sa veľmi pačilo a určite sa vám ešte ozveme, aby sme si výletik s Californiou znovu zopakovali. Prajeme všetko dobré a nech auto slúži každému minimálne tak dobre ako nám. 👋',
    photo: '/images/review-1.jpg',
  },
];

// --- Galéria (nahraď vlastnými fotkami v public/images/) ---
export const galleryImages = [
  { src: '/images/gallery-01.jpg', alt: 'VW California Ocean – exteriér', tall: false },
  { src: '/images/gallery-02.jpg', alt: 'VW California - detail', tall: true },
  { src: '/images/gallery-03.jpg', alt: 'VW California - vysúvacia strecha', tall: false },
  { src: '/images/gallery-04.jpg', alt: 'VW California - palubná doska', tall: false },
  { src: '/images/gallery-05.jpg', alt: 'VW California - centrálny displej', tall: true },
  { src: '/images/gallery-06.jpg', alt: 'VW California - displej ovládacieho panela', tall: false },
  { src: '/images/gallery-07.jpg', alt: 'VW California - Kuchynka vo vozidle', tall: false },
  { src: '/images/gallery-08.jpg', alt: 'VW California - kávovar Nespresso', tall: true },
  { src: '/images/gallery-09.jpg', alt: 'VW California - odkladacie priestory', tall: false },
];
